import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { Responsive, Grid } from 'semantic-ui-react';
import { createSellerMareting201905 } from '../../firestore';
import { validateEmail } from '../../utils/email';

const Container = styled.div`
  background-color: #7b4bf6;
  padding: 10px;
  color: #ffffff;
`;

const Box = styled.div`
  padding: 35px 45px;
  max-width: 1004px;
  margin: 0 auto;
`;

const Input = styled.input<{ validate?: boolean }>`
  border: none;
  border-bottom: 2px solid rgba(255, 255, 255, 0.3);
  height: 38px;
  width: 100%;
  background: none;
  color: #ffffff;
  font-size: 16px;
  line-height: 22px;
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  ::placeholder {
    color: #ffffff;
    opacity: 0.6;
    font-family: 'Montserrat', sans-serif;
    font-weight: normal;
  }
  :focus {
    border-bottom: 2px solid #e4ff5f;
    outline: none;
  }
  @media (max-width: 640px) {
    width: 100%;
    display: block;
  }
  ${props =>
    props.validate &&
    css`
      border-bottom: 2px solid #9f3a38;
      color: #9f3a38;
      ::placeholder {
        color: #9f3a38;
      }
      :focus {
        border-bottom: 2px solid #9f3a38;
      }
    `}
`;

const MobileInput = styled(Input)`
  margin: 20px 0;
`;

const Button = styled.button`
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  width: 200px;
  height: 50px;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  background-color: #e4ff5f;
  font-size: 14px;
  color: #a281f4;
  border-radius: 25px 25px;
  border: none;
  outline: none;
  margin: 50px 0;
  @media (max-width: 640px) {
    margin-top: 30px;
    width: 100%;
  }
`;

const Message = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  background: rgba(255, 255, 255, 0.9);
  position: absolute;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  color: rgba(0, 0, 0, 0.4);
  top: 200px;
`;

const MessageContent = styled.div`
  padding: 40px 0;
`;

const MessageBtn = styled.div`
  cursor: pointer;
  float: right;
  line-height: 10px;
  :hover {
    color: rgba(0, 0, 0, 0.6);
  }
`;

export default ({ headerEmail }: { headerEmail: string }) => {
  const [isValidate, setIsValidate] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    instagram: '',
    website: '',
    phoneNumber: ''
  });

  useEffect(() => {
    if (headerEmail) {
      setForm({ ...form, email: headerEmail });
    }
  }, [form, headerEmail]);

  const { firstName, lastName, email, instagram, website, phoneNumber } = form;
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    setForm({ ...form, [name]: value });
  };

  return (
    <Container>
      <Box>
        <h2 className="title" style={{ marginTop: 10, textAlign: 'center' }}>
          Become a partner with Popshop Live!
        </h2>
        <Responsive minWidth={641}>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Input
                  value={firstName}
                  name="firstName"
                  placeholder="First Name*"
                  onChange={onChange}
                  validate={isValidate && !firstName}
                />
              </Grid.Column>
              <Grid.Column>
                <Input
                  value={lastName}
                  name="lastName"
                  placeholder="Last Name*"
                  onChange={onChange}
                  validate={isValidate && !lastName}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Input
                  value={email}
                  name="email"
                  placeholder="E-mail*"
                  onChange={onChange}
                  validate={Boolean(
                    (isValidate && !email) || (email && !validateEmail(email))
                  )}
                />
              </Grid.Column>
              <Grid.Column>
                <Input
                  value={instagram}
                  name="instagram"
                  placeholder="Instagram"
                  onChange={onChange}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Input
                  value={website}
                  name="website"
                  placeholder="Website"
                  onChange={onChange}
                />
              </Grid.Column>
              <Grid.Column>
                <Input
                  value={phoneNumber}
                  name="phoneNumber"
                  placeholder="Phone Number"
                  onChange={onChange}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Responsive>
        <Responsive maxWidth={640}>
          <MobileInput
            value={firstName}
            name="firstName"
            placeholder="First Name*"
            onChange={onChange}
            validate={isValidate && !firstName}
          />
          <MobileInput
            value={lastName}
            name="lastName"
            placeholder="Last Name*"
            onChange={onChange}
            validate={isValidate && !lastName}
          />
          <MobileInput
            value={email}
            name="email"
            placeholder="E-mail*"
            onChange={onChange}
            validate={Boolean(
              (isValidate && !email) || (email && !validateEmail(email))
            )}
          />
          <MobileInput
            value={instagram}
            name="instagram"
            placeholder="Instagram"
            onChange={onChange}
          />
          <MobileInput
            value={website}
            name="website"
            placeholder="Website"
            onChange={onChange}
          />
          <MobileInput
            value={phoneNumber}
            name="phone"
            placeholder="Phone Number"
            onChange={onChange}
          />
        </Responsive>
        <Button
          disabled={isSubmitting}
          onClick={async () => {
            if (firstName && lastName && email && validateEmail(email)) {
              setIsSubmitting(true);
              await createSellerMareting201905(form);
              setMessage(
                `Thank you ${firstName} ${lastName}. Your form has been submitted.`
              );
              setIsSubmitting(false);
            } else {
              setIsValidate(true);
            }
          }}
        >
          {isSubmitting ? 'Submitting' : 'Submit'}
        </Button>
        {message ? (
          <Message>
            <MessageBtn onClick={() => setMessage('')}>X</MessageBtn>
            <MessageContent>{message}</MessageContent>
          </Message>
        ) : null}
      </Box>
    </Container>
  );
};
